/* eslint-disable no-case-declarations */
import { Reducer } from 'redux'
import { DashboardState, DashboardTypes, ICourse } from './types'

const INITIAL_STATE: DashboardState = {
  preferences: {
    data: null,
    error: false,
    loading: false,
    fetched: false,
    showInformationTooltip: true,
  },
}

const reducer: Reducer<DashboardState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DashboardTypes.PREFERENCES_REQUEST:
      return { ...state, preferences: { ...state.preferences, loading: true } }

    case DashboardTypes.PREFERENCES_SUCCCESS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          loading: false,
          error: false,
          fetched: true,
          data: action.payload.data,
        },
      }

    case DashboardTypes.PREFERENCES_FAILURE:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          loading: false,
          error: true,
          fetched: true,
        },
      }

    case DashboardTypes.PREFERENCES_CHANGE_GOAL:
      const { hoursGoal, courseId } = action.payload
      return {
        ...state,
        preferences: {
          ...state.preferences,
          loading: false,
          error: false,
          fetched: true,
          data: {
            ...state.preferences.data,
            courses: {
              ...state.preferences.data.courses,
              [courseId]: { ...state.preferences.data.courses[courseId], hoursGoal },
            },
          },
        },
      }
    case DashboardTypes.PREFERENCES_SHOW_INFORMATION:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          showInformationTooltip: action.payload,
        },
      }

    default:
      return state
  }
}

export default reducer
